// @flow weak
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Col,
  PanelContainer,
  PanelHeader,
  Grid,
  Panel,
  PanelBody,
  Row,
  Icon,
} from "@sketchpixy/rubix";
import _ from "lodash";
import {
  DEFAULT_USER_IMAGE,
  DISPLAY_FORMAT_DATE,
  getScretSSN,
} from "../utils/index";
import { PatientActions } from "../reducers/patient/index";

import moment from "moment";
import NotificationSystem from "react-notification-system";
import LoadingContainer from "../components/LoadingContainer";
import ExamResumeOrNew from "../components/ExamResumeOrNew";

class PatientConfirm extends Component {
  constructor(props) {
    super(props);

    let patient =
      this.props.location && this.props.location.patient
        ? this.props.location.patient
        : JSON.parse(sessionStorage.getItem("patient"));
    this.state = {
      patient: patient,
      showExamResumeOrNew: false,
      loadingExam: false,
      diagnosesAndExtremitiesViewName: "",
      hoveredDbqId: "",
    };
    this.setDiagnosesAndExtremitiesRef =
      this.setDiagnosesAndExtremitiesRef.bind(this);
    this.handleClickOutsideDiagnosesAndExtremitiesRef =
      this.handleClickOutsideDiagnosesAndExtremitiesRef.bind(this);
    this.handleDiagnosesAndExtremitiesView =
      this.handleDiagnosesAndExtremitiesView.bind(this);
    this.popoverRefs = new Map();
  }

  actions = (link, disability) => {
    if (!disability.isSigned) {
      const { patient } = this.state;
      patient.ssn = null;
      this.setState({ loadingExam: true });

      let currentDbqProp = {
        name: disability.disabilityName,
        name_fv: disability.name_fv,
        id: disability.dbqId,
      };
      sessionStorage.setItem("currentDbq", JSON.stringify(currentDbqProp));
      sessionStorage.removeItem("signedDbq");

      this.props.getPatientDoc(
        patient && patient.id,
        disability.disabilityName,
        disability.dbqId
      );

      let token = localStorage.getItem("login_token");
      let headers = { "Content-Type": "application/json" };
      headers["Authorization"] = `Bearer ${token}`;
      let obj = {
        pId: patient && patient.id ? patient.id : "",
        dbqId: disability.dbqId,
        appointmentId: this.state.patient.apptId,
      };

      fetch(process.env.API_URL + "/dbq/exam", {
        method: "post",
        headers,
        body: JSON.stringify(obj),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data && data.questions && data.questions.length > 0) {
            patient.ssn = data.ssn;
            patient.isPreviousVersion = data.isPreviousVersion;
            this.setState({
              loadingExam: false,
              showExamResumeOrNew: true,
              questionsFromDb: data.questions,
              dbqStatusInDb: data.status,
              currentDbq: currentDbqProp,
              patient: patient,
              link,
              diagnosesAndExtremities: disability.diagnosesAndExtremities,
            });
          } else {
            console.log("Did not find Incomplete exam");
            sessionStorage.setItem("questionState", null);
            // history.push({pathname:link, currentDbq:currentDbqProp, questionState: null, patient: patient, page: "home"})
            this.loadExamQuestions(
              currentDbqProp.id,
              currentDbqProp.name,
              currentDbqProp.name_fv,
              link,
              disability.diagnosesAndExtremities
            );
          }
        })
        .catch((error) => {
          this.setState({ loadingExam: false });
          console.error("Error:", error);
        });
    }
  };

  loadExamQuestions = (
    disabalityId,
    disabilityName,
    name_fv,
    link,
    diagnosesAndExtremities
  ) => {
    const { history } = this.props;
    const { patient } = this.state;
    this.setState({ loadingExam: true });
    let token = localStorage.getItem("login_token");
    let headers = { "Content-Type": "application/json" };
    headers["Authorization"] = `Bearer ${token}`;
    fetch(
      process.env.API_URL +
        "/patients/version/" +
        disabalityId +
        "/" +
        disabilityName,
      { headers }
    )
      .then((response) => response.json())
      .then((data) => {
        let newQues = data.questions;
        sessionStorage.setItem("questionState", JSON.stringify(newQues));
        sessionStorage.setItem("page", "home");
        let currentDbqProp = {
          name: disabilityName,
          name_fv,
          id: disabalityId,
          src: data.src,
        };
        sessionStorage.setItem("currentDbq", JSON.stringify(currentDbqProp));
        patient.ssn = data.ssn;
        patient.isPreviousVersion = data.isPreviousVersion;
        sessionStorage.setItem("patient", JSON.stringify(patient));
        history.push({
          pathname: link,
          currentDbq: currentDbqProp,
          questionState: newQues,
          patient,
          page: "home",
          src: data.src,
          diagnosesAndExtremities,
        });
      })
      .catch((error) => {
        this.setState({ loadingExam: false });
        console.error("Error:", error);
      });
  };

  closeShowExamNew = (e) => {
    let {
      questionsFromDb,
      currentDbq,
      patient,
      link,
      diagnosesAndExtremities,
    } = this.state;
    const { history } = this.props;

    if (e.param === "exam" && e.src === "second") {
      sessionStorage.setItem("questionState", JSON.stringify(questionsFromDb));
      sessionStorage.setItem("patient", JSON.stringify(patient));
      sessionStorage.setItem("examIsResumed", true);
      console.log("Resumed exam in DB");
      history.push({
        pathname: link,
        currentDbq: currentDbq,
        questionState: questionsFromDb,
        patient: patient,
        page: "home",
        diagnosesAndExtremities,
      });
    } else if (e.param === "exam" && e.src === "first") {
      console.log("Start over new exam");
      sessionStorage.setItem("questionState", null);
      sessionStorage.removeItem("page");
      this.loadExamQuestions(
        currentDbq.id,
        currentDbq.name,
        currentDbq.name_fv,
        link,
        diagnosesAndExtremities
      );
    }
    this.setState({ showExamResumeOrNew: false });
  };

  setDiagnosesAndExtremitiesRef(node) {
    this.diagnosesAndExtremitiesRef = node;
  }

  setPopoverRef = (disabilityId, node) => {
    if (node) {
      this.popoverRefs.set(disabilityId, node);
    } else {
      this.popoverRefs.delete(disabilityId);
    }
  }

  handleClickOutsideDiagnosesAndExtremitiesRef(event) {
    if (!this.state.diagnosesAndExtremitiesViewName) return;

    let target = event && event.target ? event.target : null;
    let targetId = event && event.target && event.target.id
      ? event.target.id
      : "";
    let popoverElement = this.popoverRefs.get(
      this.state.diagnosesAndExtremitiesViewName
    );

    if (!target || targetId.includes("diagnosesAndExtremities-")) return;
    if (popoverElement && popoverElement.contains(target)) return;

    this.setState({ diagnosesAndExtremitiesViewName: "" });
  }

  handleDiagnosesAndExtremitiesView(viewName, event) {
    event.stopPropagation();
    if (this.state.diagnosesAndExtremitiesViewName === viewName) {
      this.setState({ diagnosesAndExtremitiesViewName: "" });
    } else {
      this.setState({ diagnosesAndExtremitiesViewName: viewName });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.diagnosesAndExtremitiesViewName !==
        prevState.diagnosesAndExtremitiesViewName &&
      this.state.diagnosesAndExtremitiesViewName !== ""
    ) {
      const popoverElement = this.popoverRefs.get(
        this.state.diagnosesAndExtremitiesViewName
      );
      if (popoverElement) {
        popoverElement.scrollTop = 0;
      }
    }
  }

  componentDidMount() {
    let patient = this.state.patient;
    let signedDbq = sessionStorage.getItem("signedDbq")
      ? JSON.parse(sessionStorage.getItem("signedDbq"))
      : "";

    this._notificationSystem = this.refs.notificationSystem;
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideDiagnosesAndExtremitiesRef
    );

    if (patient.disabilities && patient.disabilities.length > 0) {
      for (let i = 0; i <= patient.disabilities.length; i++) {
        if (patient.disabilities[i] && patient.disabilities[i].dbqId === signedDbq.id) {
          patient.disabilities[i].isSigned = true;
          break;
        }
      }
    }
    sessionStorage.setItem("patient", JSON.stringify(patient));
    this.setState({ patient });
    if (this.props.location && this.props.location.isSign) {
      this._addNotification();
    }
    sessionStorage.getItem('currentDiagnosesAndExtremities') && sessionStorage.removeItem('currentDiagnosesAndExtremities');
    sessionStorage.getItem('currentDbq') && sessionStorage.removeItem('currentDbq');
    sessionStorage.getItem('questionState') && sessionStorage.removeItem('questionState');
    sessionStorage.getItem('fileUrl') && sessionStorage.removeItem('fileUrl');
    sessionStorage.getItem('selectedLicense') && sessionStorage.removeItem('selectedLicense');
    sessionStorage.getItem('signedDbq') && sessionStorage.removeItem('signedDbq');
  }

  componentWillUnmount() {
    document.removeEventListener(
      "mousedown",
      this.handleClickOutsideDiagnosesAndExtremitiesRef
    );
    this.popoverRefs.clear();
  }

  _addNotification = () => {
    this._notificationSystem.clearNotifications();
    this._notificationSystem.addNotification({
      level: "info",
      position: "br",
      autoDismiss: 10,
      children: (
        <div style={{ display: "flex", width: "100%", paddingTop: "5px" }}>
          <div
            style={{
              width: "30%",
              lineHeight: "45px",
              paddingTop: "7px",
              paddingLeft: "15px",
            }}
          >
            <Icon
              glyph="glyphicon glyphicon-refresh glyphicon-spin"
              style={{ fontSize: "2.7em" }}
            />
          </div>
          <div style={{ width: "69%" }}>
            <p style={{ marginBottom: 0 }}>Sending DBQ to VBG</p>
            <p style={{ marginBottom: 0 }}>Please don't close app ...</p>
          </div>
        </div>
      ),
    });
  };

  showDisabilities = (patient, name) => {
    let signedDbq = sessionStorage.getItem("signedDbq")
      ? JSON.parse(sessionStorage.getItem("signedDbq"))
      : "";

    let signedDbqId = signedDbq && signedDbq.id ? signedDbq.id : "";
    let time =
      signedDbq &&
      signedDbq.time &&
      (new Date().getTime() - signedDbq.time) / 1000 < 120
        ? true
        : false;

    let disabilities = patient.disabilities;
    let disabilitiesCompnent = [];
    // let alreadySignedDbqs, disabilitiesCompnent = []
    // let signedLocalDbqs = localStorage.getItem('signedDbqs') ? JSON.parse(localStorage.getItem('signedDbqs')): '';
    // signedLocalDbqs && signedLocalDbqs.forEach(function (signedDbqObj) {
    //   if (signedDbqObj.patientId === patient.id) {
    //       alreadySignedDbqs = signedDbqObj.signedDbq.split("#")
    //       alreadySignedDbqs = _.uniq(alreadySignedDbqs)
    //       console.log("alreadySignedDbqs", alreadySignedDbqs)
    //   }
    // })
    _.forEach(disabilities && disabilities, (disbaility) => {
      //let isDbqAlreadySigned = alreadySignedDbqs.includes(disbaility.name.toLowerCase());
      let imgSrc = "/imgs/app/vbg-icons";
      let disabilityId = disbaility.dbqId || disbaility.name;
      let isUnableToExamine = disbaility.status_c === "Unable to Examine";
      let isHovered = this.state.hoveredDbqId === disabilityId;
      if (disbaility.isSigned || (disbaility.dbqId === signedDbqId && time)) {
        imgSrc = "/imgs/app/vbg-icons-green";
      }

      disbaility.name &&
        disabilitiesCompnent.push(
          <div
            key={"patientConfirmDbq" + disabilityId}
            style={
              isUnableToExamine
                ? {
                    filter: "grayscale(1)",
                    textAlign: "center",
                    boxSizing: "border-box",
                    flex: "0 1 180px",
                    minHeight: "145px",
                    maxWidth: "210px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    marginBottom: "0",
                    padding: "10px",
                    border: "1px solid transparent",
                    borderRadius: "6px",
                  }
                : {
                    textAlign: "center",
                    boxSizing: "border-box",
                    flex: "0 1 180px",
                    minHeight: "145px",
                    maxWidth: "210px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    marginBottom: "0",
                    cursor: "pointer",
                    padding: "10px",
                    border: isHovered
                      ? "1px solid #d8e7f0"
                      : "1px solid transparent",
                    borderRadius: "6px",
                    backgroundColor: isHovered ? "#f5f9fc" : "transparent",
                    transition:
                      "background-color 120ms ease, border-color 120ms ease",
                  }
            }
            onMouseEnter={
              isUnableToExamine
                ? undefined
                : () => this.setState({ hoveredDbqId: disabilityId })
            }
            onMouseLeave={
              isUnableToExamine
                ? undefined
                : () => this.setState({ hoveredDbqId: "" })
            }
            onClick={
              isUnableToExamine
                ? undefined
                : this.actions.bind(this, `/admin/exam`, {
                    name: patient.name,
                    disabilityName: disbaility.name,
                    name_fv: disbaility.name_fv,
                    dbqId: disbaility.dbqId,
                    isSigned: disbaility.isSigned,
                    diagnosesAndExtremities:
                      disbaility.diagnosesAndExtremities,
                  })
            }
          >
            <div>
              <img
                src={imgSrc + "/" + disbaility.name_fv.toLowerCase() + ".png"}
                width="80px"
                alt={disbaility.name_fv + " image"}
              ></img>
            </div>
            <div
              style={{
                textTransform: "capitalize",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <h4 style={{ marginBottom: 0 }}>{disbaility.name_fv}</h4>
              {disbaility.diagnosesAndExtremities &&
                disbaility.diagnosesAndExtremities.length !== 0 && (
                  <span
                    style={{ position: "relative", marginLeft: "5px" }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <sup>
                      <img
                        src="/imgs/app/info-circle.svg"
                        alt="More info"
                        width="18"
                        height="18"
                        style={{ cursor: "pointer" }}
                        onClick={this.handleDiagnosesAndExtremitiesView.bind(
                          this,
                          disabilityId
                        )}
                        id={`diagnosesAndExtremities-${disabilityId}`}
                      />
                    </sup>
                    <span
                      className="diagnoses-extremities-popup custom-scrollbar"
                      ref={(node) => this.setPopoverRef(disabilityId, node)}
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        display:
                          this.state.diagnosesAndExtremitiesViewName ===
                          disabilityId
                            ? "inline"
                            : "none",
                      }}
                    >
                      {disbaility.diagnosesAndExtremities.map(
                        (moreInfo, index) => (
                          <span key={moreInfo.diagnosis + index}>
                            <p>Diagnosis: {moreInfo.diagnosis}</p>
                            {moreInfo.extremity && (
                              <p>Extremity: {moreInfo.extremity}</p>
                            )}
                            {moreInfo.icdCode && (
                              <p>ICD Code: {moreInfo.icdCode}</p>
                            )}
                            {disbaility.diagnosesAndExtremities.length - 1 !==
                              index && <br />}
                          </span>
                        )
                      )}
                    </span>
                  </span>
                )}
            </div>
          </div>
        );
    });
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "flex-start",
          alignItems: "stretch",
          gap: "16px",
          marginTop: "10px",
          marginLeft: "0",
          marginRight: "0",
          maxWidth: "100%",
        }}
        ref={this.setDiagnosesAndExtremitiesRef}
      >
        {disabilitiesCompnent}
      </div>
    );
  };

  render() {
    const { patient = undefined } = this.state;

    let style = {
      NotificationItem: {
        // Override the notification item
        DefaultStyle: {
          // Applied to every notification, regardless of the notification level
          padding: "10px",
          "background-color": "#022144",
          "border-radius": "10px",
          color: "white",
          "border-top": "none",
        },
      },
    };

    return (
      <div className="show-with-ease">
        <Row>
          {this.state.showExamResumeOrNew && (
            <ExamResumeOrNew
              status={false}
              onClose={this.closeShowExamNew}
            />
          )}
          {this.state.loadingExam && <LoadingContainer />}
          <Col sm={10} className="col-sm-offset-1">
            <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow">
              <Panel>
                <PanelHeader
                  className="bg-custome-red vbg-panel-header"
                  style={{ marginBottom: 0 }}
                >
                  <Grid>
                    <Row>
                      <Col sm={12} className="fg-white"></Col>
                    </Row>
                  </Grid>
                </PanelHeader>
                <PanelBody
                  className="home-panel-body-user-request-height"
                  style={{ paddingBottom: 40 }}
                >
                  <Row>
                    <Col sm={4} style={{ textAlign: "center" }}>
                      <div style={{ marginTop: 50, marginBottom: 50 }}>
                        <div>
                          {" "}
                          <img
                            src={
                              patient && patient.picture && patient.picture.url
                                ? patient.picture.url
                                : DEFAULT_USER_IMAGE
                            }
                            className="main-img-circle"
                            alt=""
                          />
                        </div>
                        <h2 style={{ marginTop: "13px", marginBottom: "0px" }}>
                          <strong className="fg-custome-blue ">
                            {patient && patient.name}
                          </strong>
                        </h2>

                        <div style={{ fontSize: "18px" }}>
                          <div>
                            Appointment:{" "}
                            {patient &&
                              moment(patient.apptTime, "hh:mm").format("LT")}
                          </div>
                          <div>DOB: {patient && patient.birthdate}</div>
                          <div>
                            SSN:{" "}
                            {patient &&
                              getScretSSN(0, "XXX-XX", patient.ssn_encrypt_c)}
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col sm={8} className="">
                      <div className="text-left" style={{ marginTop: 30 }}>
                        <h1
                          className="fg-custome-blue"
                          style={{
                            margin: 0,
                            marginTop: 15,
                            paddingBottom: 0,
                            fontWeight: "bold",
                          }}
                        >
                          DBQs to Evaluate
                        </h1>
                        <h4>Select a disability to begin</h4>
                        <div style={{ marginTop: 50 }}>
                          {this.showDisabilities(patient)}

                          {/* <Button
                                lg
                                outlined
                                type='button'
                                bsStyle='custome-blue'
                                style={{marginRight: 20, marginBottom: 20}}
                                
                                // onClick={this.actions.bind(this, `/admin/confirmDisability`)}
                            ><span style={{padding:20}}>+ Add</span></Button> */}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <NotificationSystem ref="notificationSystem" style={style} />
                </PanelBody>
              </Panel>
            </PanelContainer>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = ({ fetching }) => ({ fetching });

const mapDispatchToProps = (dispatch) => ({
  getPatientDoc: (id, dbq, dbqId) => {
    dispatch(
      PatientActions.getSpecificPatientDocumentRequest({
        id,
        dbq,
        dbqId,
      })
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientConfirm);
